import React from 'react';
import * as R from 'ramda';
import Details from './details/Details.connector';
import {
  fetchInactiveSelfAuthorizations,
  getStepTwoDisableContinue,
  resetWizardData,
  setHasUnsavedChanges,
} from '../store/createNewSelfAuthorizationSlice';
import ConfirmAndSubmit from './confirm-and-submit/ConfirmAndSubmit.connector';
import SelectProduct from './select-product/SelectProduct.connector';

const newSelfAuthSteps = [
  {
    component: <Details />,
    disabled: store => {
      const {
        params: { affiliate, selfAuthType, productId, locationId },
        inactiveListLoading,
      } = store.loadingManagement.createNewSelfAuth;
      // disable the button if affiliate or selfAuthType are empty or undefined in params
      const isEmpty = R.any(R.either(R.isEmpty, R.isNil), [affiliate, selfAuthType]);
      // plus if both productId and LocationId are empty
      const isEmptyType = !locationId && !productId;
      return isEmpty || isEmptyType || inactiveListLoading;
    },
    goNext: dispatch => dispatch(fetchInactiveSelfAuthorizations()),
    id: 1,
    loading: R.F,
    rightLabel: 'Continue',
    showSpinner: store => store.loadingManagement.createNewSelfAuth.inactiveListLoading,
    stepLabel: R.always('Details'),
  },
  {
    component: <SelectProduct />,
    disabled: getStepTwoDisableContinue,
    goBack: R.F,
    goNext: (dispatch, setCurrentStepIdx) => {
      dispatch(setHasUnsavedChanges(false));
      return setCurrentStepIdx(2);
    },
    id: 2,
    leftLabel: 'Back',
    loading: R.F,
    rightLabel: 'Submit',
    showSpinner: R.F,
    stepLabel: store => {
      const { authorizationBy } = store.loadingManagement.createNewSelfAuth;
      return authorizationBy === 'location' ? 'Select Products' : 'Select Locations';
    },
  },
  {
    component: <ConfirmAndSubmit />,
    disabled: state => state.loadingManagement.createNewSelfAuth.submittingBatch,
    goBack: (dispatch, setCurrentStepIdx) => {
      dispatch(resetWizardData());
      setCurrentStepIdx(0);
      return true;
    },
    id: 3,
    leftLabel: 'Create New',
    loading: R.F,
    rightLabel: 'Done',
    showSpinner: state => state.loadingManagement.createNewSelfAuth.submittingBatch,
    stepLabel: R.always('Progress'),
  },
];

export default newSelfAuthSteps;
